import React from 'react';
import classNames from 'classnames';
import _ from 'lodash';
import { Tabs } from 'antd';
import { connect } from 'react-redux';
import ManualSearchSources from '../ManualSearchSources/ManualSearchSources';
import styles from './ManualSearchForm.module.scss';
import SearchCriteria from '../SearchCriteria/SearchCriteria';
import AdvancedCriteria from '../AdvancedCriteria/AdvancedCriteria';
import ManualSearchFormFooter from '../ManualSearchFormFooter/ManualSearchFormFooter';
import {
  getConfig,
  getPortalsConfig,
  getWhiteLabelInformation,
  getConfiguredSources,
} from '../../../Reducers/ConfigReducer';
import * as manualSearchActions from '../../../Actions/ManualSearchActions';
import * as scoutingAgentActions from '../../../Actions/ScoutingAgentActions';
import { getIndustrySuggestions, getJobDetails } from '../../../Reducers/JobReducer';
import ManualSearchFormHeaderOptions from '../HeaderOptions/ManualSearchFormHeaderOptions';
import { getInitialSources } from '../../../Utils/ManualSearchUtils';
import {
  getManualSearchSelectedCriteriaName,
  getBooleanSearchStrings,
  getManualSearchFormValues,
} from '../../../Reducers/ManualSearchReducer';
import { getCurrentUserDetails } from '../../../Reducers/UserSessionReducer';
import {
  getScoutingAgentWarningModalVisiblityStatus,
  getScoutingAgentSearchCriteriaModalStatus,
} from '../../../Reducers/ScoutingAgentReducer';
import ManualSearchContext from '../ManualSearchWrapper/ManualSearchContext';

import WarningModal from '../ScoutingAgent/WarningModal';

const mapStateToProps = (state, props) => ({
  userConfig: getConfig(state),
  portalsConfig: getPortalsConfig(state),
  sources: getConfiguredSources(state),
  industries: getIndustrySuggestions(state),
  criteriaName: getManualSearchSelectedCriteriaName(state, { jobId: props.jobId }),
  currentUserDetails: getCurrentUserDetails(state),
  booleanSearchStrings: getBooleanSearchStrings(state),
  scoutingAgentWarningModalVisibilityStatus: getScoutingAgentWarningModalVisiblityStatus(state),
  manualSearchFormValues: getManualSearchFormValues(state, { jobId: props.jobId }),
  whiteLabelInfo: getWhiteLabelInformation(state),
  currentJobDetails: getJobDetails(state, props.jobId),
  isScoutingAgentSearchCriteriaModalVisible: getScoutingAgentSearchCriteriaModalStatus(state),
});

const mapDispatchToProps = {
  fetchBooleanSearchStrings: manualSearchActions.fetchBooleanSearchStrings,
  setScoutingAgentWarningModalVisibilityStatus: scoutingAgentActions.setScoutingAgentWarningModalVisibility,
  setScoutingAgentDrawerVisibility: scoutingAgentActions.setScoutingAgentDrawerVisibility,
  setSelectedScoutingAgentId: scoutingAgentActions.setSelectedScoutingAgentIdAction,
  setIsScoutingAgentSearchCriteriaModalVisible: scoutingAgentActions.setScoutingAgentSearchCriteriaModalVisibility,
};

const tabBarStyle = {
  paddingLeft: '20px',
};

function isNumericString(str) {
  return /^\d+$/.test(str);
}

const tabPaneStyle = { padding: '0px 20px 40px 20px', overflow: 'hidden' };
const advancedOptionsTabPaneStyle = { padding: '0px 20px 20px 20px', overflow: 'hidden' };

function ManualSearchForm(props) {
  const {
    industries,
    unsavedCriteriaId,
    defaultFormValues,
    userConfig,
    portalsConfig,
    jobId,
    currentJobDetails,
    sources,
    onSearchCandidates,
    isManualSearchFormMinimized,
    handleShowMoreLessClick,
    setDefaultFormValues,
    criteriaName,
    currentUserDetails,
    booleanSearchStrings,
    fetchBooleanSearchStrings,
    whiteLabelInfo,
    candidateContext = 'job',
    history,
    isNonInternalPortalForSegmentEnabled,
    setScoutingAgentWarningModalVisibilityStatus: setWarningModalStatus,
    scoutingAgentWarningModalVisibilityStatus: warningModalStatus,
    setScoutingAgentDrawerVisibility,
    setSelectedScoutingAgentId,
    isScoutingAgentSearchCriteriaModalVisible,
    setIsScoutingAgentSearchCriteriaModalVisible,
  } = props;
  const [selectedCriteriaId, setSelectedCriteriaId] = React.useState();

  const onSelect = id => {
    setIsScoutingAgentSearchCriteriaModalVisible(true);
    setSelectedCriteriaId(id);
    if (!isNumericString(id)) setSelectedScoutingAgentId(id);
  };
  const { form, minimizeManualSearchForm } = React.useContext(ManualSearchContext);
  const sourcesConfig = userConfig?.Sources;
  const updatedSource =
    candidateContext === 'segment' && !isNonInternalPortalForSegmentEnabled
      ? sources.filter(source => source.Portal === 'Internal')
      : sources;

  const { PortalQueries: defaultPortalQueries = {}, Sources: defaultSources } = defaultFormValues;
  form.getFieldDecorator('advancedSettings', {
    initialValue: {},
  });
  form.getFieldDecorator('sourceNamesSelected');

  const isAllPortalsAllowed = candidateContext === 'job' || isNonInternalPortalForSegmentEnabled;
  const advancedSettings = form.getFieldValue('advancedSettings');
  const setAdvancedSettings = _advancedSettings => form.setFieldsValue({ advancedSettings: _advancedSettings });

  const sourceNamesSelected = form.getFieldValue('sourceNamesSelected');
  const setSelectedSourceNames = x => form.setFieldsValue({ sourceNamesSelected: x });

  // TODO: Optimise new object creation always?
  const mergedAdvancedSettings = { ...defaultPortalQueries, ...advancedSettings };
  const _sources =
    candidateContext === 'segment' && !isNonInternalPortalForSegmentEnabled
      ? sources?.filter(x => x.Portal === 'Internal')
      : sources;

  const _sourceNamesSelected = sourceNamesSelected?.length
    ? sourceNamesSelected
    : getInitialSources({
        jobCountryCode: currentJobDetails.CountryCode,
        userConfig,
        sources: defaultSources?.length && isAllPortalsAllowed ? defaultSources : _sources,
        portalsConfig,
        allowActiveChannel: true,
      });
  const currentSources = defaultSources?.length && isAllPortalsAllowed ? defaultSources : _sources;
  const initalSources = getInitialSources({
    jobCountryCode: currentJobDetails.CountryCode,
    userConfig,
    sources: currentSources,
    portalsConfig,
    allowActiveChannel: true,
  });
  const buttonName = isManualSearchFormMinimized ? 'View/Edit Search Criteria' : 'Show Less';

  const toggleManualSearchFormExpansion = () => {
    if (isManualSearchFormMinimized) minimizeManualSearchForm(false);
  };

  return (
    <>
      <WarningModal
        showWarningModal={warningModalStatus}
        setWarningModal={setWarningModalStatus}
        setScoutingAgentDrawerVisibility={setScoutingAgentDrawerVisibility}
      />
      <div
        className={classNames(styles.manualSearchFormWrapper, {
          [styles.manualSearchFormMinimizedView]: isManualSearchFormMinimized,
        })}
        onKeyPress={toggleManualSearchFormExpansion}
        onClick={toggleManualSearchFormExpansion}
        role="button"
        tabIndex={0}
      >
        <div className={`${styles.manualSearchForm} ${isManualSearchFormMinimized ? styles.minimize : ''}`}>
          <div className={styles.manualSearchSources}>
            <ManualSearchSources
              form={form}
              sources={updatedSource}
              sourcesConfig={sourcesConfig}
              advancedSettings={advancedSettings}
              defaultAdvancedSettings={mergedAdvancedSettings}
              setAdvancedSettings={setAdvancedSettings}
              sourceNamesSelected={_sourceNamesSelected}
              setSelectedSourceNames={setSelectedSourceNames}
              currentJobDetails={currentJobDetails}
              jobId={jobId}
              candidateContext={candidateContext}
              isNonInternalPortalForSegmentEnabled={isNonInternalPortalForSegmentEnabled}
            />
          </div>
          <div className={styles.candidateCollapsedFilters}>
            <ManualSearchFormHeaderOptions
              jobId={jobId}
              setDefaultFormValues={setDefaultFormValues}
              form={form}
              onSelect={onSelect}
              jobGuid={currentJobDetails.JobGuid}
              advancedSettings={mergedAdvancedSettings}
              currentUserDetails={currentUserDetails}
              setAdvancedSettings={setAdvancedSettings}
              AppName={_.get(whiteLabelInfo, ['AppName'], 'Leoforce')}
              candidateContext={candidateContext}
            />
            {criteriaName ? <div className={styles.savedCriteria}>Saved criteria: {criteriaName}</div> : null}
            <Tabs tabBarStyle={tabBarStyle} className={styles.manualSearchTabs}>
              <Tabs.TabPane tab="Search Candidates" key="1" forceRender style={tabPaneStyle}>
                <SearchCriteria
                  jobId={jobId}
                  booleanSearchStrings={booleanSearchStrings}
                  fetchBooleanSearchStrings={fetchBooleanSearchStrings}
                  form={form}
                  defaultFormValues={defaultFormValues}
                  isManualSearchFormMinimized={isManualSearchFormMinimized}
                  currentUserDetails={currentUserDetails}
                  candidateContext={candidateContext}
                />
              </Tabs.TabPane>
              <Tabs.TabPane tab="Advanced Options" key="2" forceRender style={advancedOptionsTabPaneStyle}>
                <AdvancedCriteria
                  form={form}
                  defaultFormValues={defaultFormValues}
                  industries={industries}
                  candidateContext={candidateContext}
                />
              </Tabs.TabPane>
            </Tabs>
            <ManualSearchFormFooter
              form={form}
              unsavedCriteriaId={unsavedCriteriaId}
              jobId={jobId}
              jobGuid={currentJobDetails.JobGuid}
              advancedSettings={mergedAdvancedSettings}
              sourceNamesSelected={_sourceNamesSelected}
              initalSources={initalSources}
              setAdvancedSettings={setAdvancedSettings}
              setDefaultFormValues={setDefaultFormValues}
              selectedCriteriaName={criteriaName}
              onSearchCandidates={onSearchCandidates}
              candidateContext={candidateContext}
              isNonInternalPortalForSegmentEnabled={isNonInternalPortalForSegmentEnabled}
              history={history}
              isManualSearchFormMinimized={isManualSearchFormMinimized}
              isModalVisible={isScoutingAgentSearchCriteriaModalVisible}
              setIsModalVisible={setIsScoutingAgentSearchCriteriaModalVisible}
              selectedCriteriaId={selectedCriteriaId}
              setSelectedCriteriaId={setSelectedCriteriaId}
            />
          </div>
        </div>
      </div>
      <div
        className={styles.seeMoreLessWrapper}
        role="button"
        tabIndex={0}
        onClick={() => handleShowMoreLessClick(!isManualSearchFormMinimized)}
        onKeyPress={() => handleShowMoreLessClick(!isManualSearchFormMinimized)}
      >
        <div className={styles.seeLessButton}>{buttonName}</div>
      </div>
    </>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ManualSearchForm);
export { ManualSearchForm as ManualSearchFormWithoutStore };
